module.exports = __webpack_public_path__ + "img/weddings_12_V.72f1d0d5.webp";